import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { replyYopValidation } from './replyValidation';

import RepliesFormInner from './RepliesFormInner';
import validate from '../../../../../utils/validate';
import { mapScoutTabsToAssistantCategories } from '../../../../../constants';

function RepliesForm({ onReply }) {
  const { id } = useParams();
  const dispatch = useDispatch();

  const channels = useSelector((state) => state.scout.generationForm.channels);
  const scoutTab = useSelector((state) => state.scout.scoutTab);

  const repliesFormInitialValues = {
    hint: channels[mapScoutTabsToAssistantCategories[scoutTab]]?.hint,
    reply: '',
  };

  const handleSubmit = (values) => {
    dispatch(onReply({ id, reply: values.reply }));
  };

  return (
    <Form
      initialValues={repliesFormInitialValues}
      onSubmit={handleSubmit}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, replyYopValidation())}
      render={({ handleSubmit }) => <RepliesFormInner onSubmit={handleSubmit} />}
    />
  );
}

export default RepliesForm;
